export default __webpack_public_path__ + "static/media/background-profile-mobile.e6c3e2e5.png";